module.exports = __webpack_public_path__ + "img/saving-icon.26b601f0.svg";